<template>
  <div class="swxy-container">
    <div class="header">
      <h2>{{ appName }}声纹信息保护及使用协议</h2>
      <p class="effective-date">生效日期：2024年10月1日</p>
    </div>

    <div class="content">
      <p>
        欢迎使用{{ appName }}的声纹相关功能。{{ companyName }}（以下简称“我们”）重视您的个人信息和隐私保护。
        声纹信息属于具有较高敏感性的个人信息，您在使用相关功能前，请仔细阅读并充分理解本协议。
      </p>

      <h2>一、协议适用范围</h2>
      <p>
        本协议适用于您使用{{ appName }}提供的声音采集、声纹识别、声音处理、声音生成及其他相关功能时，
        我们对声纹信息及相关个人信息的收集、使用、存储、删除和保护。
      </p>

      <h2>二、我们处理的声纹信息</h2>
      <p>根据您使用的具体功能，我们可能处理以下信息：</p>
      <ol>
        <li>您主动上传或录制的声音文件、语音内容及其相关元数据。</li>
        <li>从声音文件中提取的声纹特征、音色特征及其他用于完成服务的技术数据。</li>
        <li>使用功能时产生的账号、设备、IP地址、操作时间和服务日志等必要信息。</li>
      </ol>
      <p>
        我们只在实现具体功能所必需的范围内处理上述信息，不会将声纹信息用于与您使用的功能无关的目的。
      </p>

      <h2>三、处理目的和使用方式</h2>
      <p>我们可能将相关信息用于以下目的：</p>
      <ol>
        <li>实现声纹识别、身份验证、声音转换、声音生成或您主动选择的其他功能。</li>
        <li>保障账号、服务和交易安全，识别异常操作，防止滥用、欺诈和侵权行为。</li>
        <li>改进服务的稳定性、兼容性和安全性，并处理您的客服、反馈和投诉。</li>
      </ol>

      <h2>四、授权、保管和删除</h2>
      <p>
        声纹相关功能仅在您主动使用、上传或录制声音时启用。您可以停止使用相关功能，并根据页面提示删除您提交的内容。
        在达到处理目的、保存期限届满，或您依法提出删除请求后，我们会按照法律法规和业务实际删除或匿名化处理相关信息，
        法律法规另有规定的除外。
      </p>
      <p>
        我们会采取访问控制、加密、权限管理和安全审计等合理措施保护声纹信息。请您妥善保管账号和设备，
        不要通过{{ appName }}上传不必要的敏感信息。
      </p>

      <h2>五、第三方服务和信息提供</h2>
      <p>
        为实现必要的存储、计算、内容处理和安全服务，我们可能委托具备相应安全能力的服务提供商处理相关信息，
        并要求其按照我们的指示、本协议及适用法律保护信息安全。我们不会出售您的声纹信息。
      </p>
      <p>
        除非获得您的单独同意、法律法规要求，或为保护{{ appName }}、用户及公众的合法权益所必需，
        我们不会向无关第三方提供您的声纹信息。
      </p>

      <h2>六、您上传他人声音的责任</h2>
      <p>
        如果您上传、录制或处理他人的声音，您应当事先取得声音提供者的合法、充分、明确授权，
        并确保使用方式、使用范围和使用期限符合授权约定。您不得利用{{ appName }}制作冒充他人、欺诈、骚扰、诽谤、
        侵犯他人隐私或其他违法违规的内容。
      </p>
      <p>
        因您未取得合法授权或违反法律法规、平台规则而产生的责任，由您自行承担；我们有权对相关内容采取限制使用、删除或其他措施。
      </p>

      <h2>七、未成年人保护</h2>
      <p>
        未满18周岁的未成年人应在父母或其他监护人同意和指导下使用声纹相关功能。监护人认为未成年人的信息被不当处理时，
        可以通过本协议载明的方式联系我们。
      </p>

      <h2>八、您的权利和联系我们</h2>
      <p>
        在符合法律法规和实际业务条件的情况下，您可以申请查阅、更正、删除相关个人信息，或撤回对特定功能的授权。
        如您对本协议或声纹信息处理有疑问、意见或投诉，可以通过{{ appName }}提供的在线客服或其他联系方式与我们联系。
      </p>

      <h2>九、协议更新</h2>
      <p>
        随着{{ appName }}功能、法律法规或安全措施变化，我们可能更新本协议并在页面公布更新后的内容。
        如果更新涉及您的重要权益，我们会采用合理方式提示您。更新后的协议公布后继续使用相关功能，视为您已阅读并同意更新内容。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Swxy',
  data() {
    return {
      appName: this.$siteConfig.siteName,
      companyName: this.$siteConfig.companyName
    }
  },
  methods: {
    loadQueryNames() {
      var paramAppName = this.$route.query.appname
      if (paramAppName && typeof paramAppName === 'string') this.appName = paramAppName

      var paramCompanyName = this.$route.query.companyname
      if (typeof paramCompanyName === 'string' && paramCompanyName.trim()) {
        this.companyName = paramCompanyName.trim()
      } else {
        this.companyName = this.appName
      }

      document.title = this.appName + '-声纹协议'
    }
  },
  mounted() {
    this.loadQueryNames()
  },
  watch: {
    '$route.query': {
      handler() {
        this.loadQueryNames()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.swxy-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  color: #333;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.header {
  margin-bottom: 30px;
  text-align: center;
}

.header h2 {
  margin: 0 0 12px;
  color: #2c3e50;
  font-size: 24px;
}

.effective-date {
  margin: 0;
  color: #7f8c8d;
  font-size: 14px;
}

.content {
  line-height: 1.8;
}

.content h2 {
  margin: 28px 0 14px;
  color: #2c3e50;
  font-size: 20px;
}

.content p {
  margin: 0 0 15px;
}

.content ol {
  margin: 0 0 15px;
  padding-left: 24px;
}

.content li {
  margin-bottom: 8px;
}

@media (max-width: 640px) {
  .swxy-container {
    padding: 16px;
  }

  .header {
    margin-bottom: 24px;
  }

  .header h2 {
    font-size: 20px;
    line-height: 1.5;
  }

  .content {
    font-size: 14px;
    line-height: 1.75;
  }

  .content h2 {
    margin-top: 24px;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/service/Swxy.vue